"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { getTimeAgo, getSectionUrl } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  category?: FieldConfig;
  sectionUrl?: string;
  slug?: string;
  templatetype?: FieldConfig;
};

export const VerticalCategoryNews = ({
  title = { hidden: false, value: "யார் கமலின் பெரிய ரசிகர்? இந்த சந்தைையில் சட்டை கிழியாது: லோகேஷ் புகழ்ந்த கொளத்தம் மேனன்!", customClass: "" },
  timeAgo = { hidden: false, value: "1 hour ago", customClass: "" },
  category = { hidden: false, value: "India", customClass: "" },
  sectionUrl,
  slug,
  templatetype  = { hidden: false, value: "", customClass: "" },
}: Props) => {
  const router = useRouter();

  const titleValue = title?.value || "";
  const timeAgoValue = getTimeAgo(timeAgo?.value);
  const categoryValue = category?.value || "";
  const isLiveBlog = templatetype?.value === "live-blog" || templatetype?.value === "true";
  const sectionUrlValue = getSectionUrl(sectionUrl);

  const handleCategoryClick = (e: React.MouseEvent) => {
    if (sectionUrlValue) {
      e.preventDefault();
      e.stopPropagation();
      router.push(sectionUrlValue);
    }
  };

  const content = (
    <div className="flex flex-col overflow-hidden p-4 gap-4">
      {/* CONTENT */}
      <div className="flex flex-col gap-3">
        {/* Category */}
        {!category?.hidden && (
          sectionUrlValue ? (
            <span
              className={`text-11-tamil-600 text-012061 uppercase tracking-wide hover:underline cursor-pointer ${category?.customClass || ""}`}
              onClick={handleCategoryClick}
            >
              {categoryValue}
            </span>
          ) : (
            <p className={`text-11-tamil-600 text-012061 uppercase tracking-wide ${category?.customClass || ""}`}>
              {categoryValue}
            </p>
          )
        )}

        {/* Headline */}
        {!title?.hidden && (
          <p className={`text-14-tamil-700 leading-[1.4] text-1B1B1B ${title?.customClass || ""}`}>
            {isLiveBlog && (
              <span className="inline-flex items-center mr-2 align-middle">
                <span className="relative inline-flex h-4 w-4 items-center justify-center">
                  <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-40 animate-[wave_1.5s_ease-out_infinite]" />
                  <span className="absolute inline-flex h-3 w-3 rounded-full bg-red-500 opacity-60 animate-[wave_1.5s_ease-out_0.3s_infinite]" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-red-600" />
                </span>
              </span>
            )}
            {titleValue}
          </p>
        )}

        {/* Footer */}
        <div className="flex justify-between items-center">
          {!timeAgo?.hidden && (
            <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
          )}
          <div className="flex gap-3">
            <MessageIcon
              id="message-icon-2"
              slug={slug}
              category={BOOKMARK_CATEGORIES.NEWS}
              title={titleValue}
              articleUrl={slug ? `/${slug}` : undefined}
            />
          </div>
        </div>
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block  transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
};
